/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable no-unsafe-optional-chaining */
import { Box, FormControl, MenuItem, Select, Tab, Tabs } from "@mui/material";
import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { isEmpty } from "lodash";
import { getListSubject } from "../utils/contants";
import { commonActions } from "../../common/redux/actions";
import { TTopicCardData, TypeListSubject } from "../utils/type";
import SubjectLessonTab from "./SubjectLessonTab";
import SubjectTabExamOrPractice from "./SubjectTabExamOrPractice";
import NoDataComponent from "../../common/components/NoData";
import {
  getDuplicateItemInArray,
  isShowLock,
  ITEMS_PER_PAGE,
  NUM_PAGE_GET_DATA_CARD,
  REPORT_QUIZ
} from "../../common/utils/constant";
import SubjectTabCard from "./SubjectTabCard";
import ModalComplain from "../../questionAndAnswer/components/ModalComplain";
import { TCommonState } from "../../common/utils/type";
import { subjectActions } from "../redux/actions";
import { CXCircularProgress } from "../../common/components/CircularProgress";

const TYPE_CARD = "card";
const TYPE_QUIZ = "quiz";

const getPersonalInfo = (data: any) => {
  const latesData = data?.latest_data;
  const personalData = data?.personal;
  if (isEmpty(personalData)) return latesData;
  const tempData = latesData?.items.map((element: { items: any[] }) => {
    return element?.items?.map((el: { id: any }) => {
      const tempNumber = personalData.findIndex((ele: { id: any }) => ele.id === el.id);
      if (tempNumber > -1) {
        return {
          ...el,
          correct_quiz: personalData[tempNumber].correct_quiz,
          correct_rate: personalData[tempNumber].correct_rate * 100,
          finished_quiz: personalData[tempNumber].finished_quiz,
          num_of_times: personalData[tempNumber].num_of_times
        };
      }
      return el;
    });
  });
  const dataNew = latesData?.items.map((element: any, index: string | number) => {
    return { ...element, items: tempData[index], type: latesData?.type };
  });
  return {
    ...latesData,
    items: dataNew
  };
};

const getTabKey = (item) => {
  return `${item?.root_tree_id}_${item?.type}`;
};

type TProps = {
  handleSetHideItems: any;
  checkIsHideItem: any;
  subjects: TypeListSubject;
  dataTopics: any;
  handleClickLink: (url: string, price?: number, isConfirm?: boolean) => void;
  handleChooseBook: (book) => void;
  bookId: number;
  handleOpenModalConfirmLogin: (accessLevel: any) => void;
  handleOpenModalConfirmPremium: () => void;
  openModalReport: boolean;
  handleOpenModalReport: (ele) => void;
  handleCloseModalReport: () => void;
  cardId: number;
  listTypeCard: TTopicCardData;
  pageCurrent: number;
  // fetchTopics: () => void;
};
export default function SubjectsView({
  handleSetHideItems,
  checkIsHideItem,
  subjects,
  dataTopics,
  handleClickLink,
  handleChooseBook,
  bookId,
  handleOpenModalConfirmLogin,
  handleOpenModalConfirmPremium,
  openModalReport,
  handleOpenModalReport,
  handleCloseModalReport,
  cardId,
  listTypeCard,
  pageCurrent
}: // fetchTopics
TProps) {
  const router = useRouter();
  const location = router.query;
  const dispatch = useDispatch();
  const [hideItems, setHideItems] = React.useState<number[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [tab, setTab] = React.useState<String>(`${subjects[0]?.topic_root_tree_id}_${subjects[0]?.type}`);

  const dataUser = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);

  const handleChangeBook = (event) => {
    handleChooseBook(event.target.value);
    dispatch(commonActions.handleChooseBook(Number(event?.target?.value)));
  };
  const listSubject = getListSubject(subjects);
  const handleGetCard = (pageStart) => {
    dispatch(
      subjectActions.handleGetListCard(
        {
          subjectId: subjects.find((item) => item.type === TYPE_CARD)?.slug,
          limit_page: NUM_PAGE_GET_DATA_CARD,
          items_per_page: ITEMS_PER_PAGE,
          page_start: pageStart || 0
        },
        () => setIsLoading(false)
      )
    );
    router.replace(
      {
        pathname: `/${location?.grade}/${location?.subjectsId}`,
        query: {
          page: (pageStart || 0) + 1
        }
      },
      undefined,
      { shallow: true }
    );
  };

  const handleChangeTab = (value) => {
    setHideItems([]);
    setTab(value);
    setIsLoading(true);
    if (value?.includes(TYPE_CARD)) {
      handleGetCard(0);
    } else {
      router.replace(
        {
          pathname: `/${location?.grade}/${location?.subjectsId}`,
          query: {}
        },
        undefined,
        { shallow: true }
      );
    }
    dispatch(subjectActions.handleChoosePage(1));
  };
  const handleSetLoading = () => {
    setIsLoading(true);
  };

  const subjectsId = location.subjectsId as string;
  const getLearningProgram = (sbId?: number) => {
    if (sbId) {
      return subjects?.find((e) => e.subject.id === sbId)?.learning_program;
    }
    return subjects?.find((e) => e?.subject?.slug === subjectsId)?.learning_program;
  };

  const listDuplicateLearningProgram = getDuplicateItemInArray(
    listSubject?.map((e) => subjects?.find((ele) => e.id === ele?.subject?.id)?.learning_program?.id)
  );
  const packageTopic: any = dataTopics.find((e) => tab === getTabKey(e?.latest_data));
  useEffect(() => {
    // khi đổi subject thì update lại tab
    const tabKey = `${subjects[0]?.topic_root_tree_id}_${subjects[0]?.type}`;
    if (tab !== tabKey) {
      setTab(tabKey);
    }
    // // F5 thi back ve tab quiz
    // router.push({ pathname: router.pathname, query: { ...router.query, tab: TYPE_QUIZ } }, undefined, {
    //   shallow: true
    // });
  }, [subjects]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      // set loading khi chuyen tab trong 500ms
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [tab]);
  useEffect(() => {
    return () => {
      dispatch(subjectActions.handleChoosePage(1));
    };
  }, []);
  return (
    <div
      className="sm:w-screen md:w-full md:px-4 sm:px-0 max-h-max"
      style={{
        display: "flex",
        flexDirection: "column",
        background: "white",
        borderRadius: 6,
        padding: "24px 16px 0px",
        minHeight: 120
      }}
    >
      <div className="sm:w-screen md:w-full">
        <div className="flex items-center flex-wrap gap-4 sm:px-2">
          {listSubject.length > 1 && (
            <div className="lg:w-1/3 sm:w-full sm2:min-w-[380px] sm2:w-[380px] lg:px-0">
              <FormControl fullWidth>
                <Select
                  className="w-full h-10 text-black rounded-[30px] focus:outline-green"
                  value={bookId ? getLearningProgram(bookId)?.title : getLearningProgram()?.title}
                  defaultValue={bookId ? getLearningProgram(bookId)?.title : getLearningProgram()?.title}
                  onChange={handleChangeBook}
                  renderValue={(value) => (
                    <span>
                      {listDuplicateLearningProgram?.includes(getLearningProgram(bookId)?.id)
                        ? `${value} - ${subjects?.find((e) => e?.subject?.id === bookId)?.subject?.title}`
                        : value}
                    </span>
                  )}
                >
                  {listSubject
                    .sort((a, b) => a?.id - b?.id)
                    .map((item, index) => (
                      <MenuItem key={index} className="menu-item text-black hover:bg-greenBland1" value={`${item?.id}`}>
                        <span>
                          {listDuplicateLearningProgram?.includes(getLearningProgram(item?.id)?.id)
                            ? `${getLearningProgram(item?.id)?.title} - ${item?.title}`
                            : getLearningProgram(item?.id)?.title}
                        </span>
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          )}
          <Tabs
            value={tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "white"
              }
            }}
          >
            {subjects
              ?.filter((item) => (bookId ? item?.subject?.id === bookId : item?.subject?.slug === subjectsId))
              ?.sort((a, b) => b?.id - a?.id)
              ?.map((element, index) => (
                <Tab
                  value={`${element.topic_root_tree_id}_${element.type}`}
                  label={element.title}
                  className={`${
                    tab === `${element.topic_root_tree_id}_${element.type}` ? "bg-primary" : "bg-gray1"
                  } sm:px-2 md:px-3 normal-case rounded-[30px] mr-2 text-white text-[13px] font-normal`}
                  key={index}
                  sx={{ height: "32px", minHeight: "32px" }}
                  disabled={tab === `${element.topic_root_tree_id}_${element.type}`}
                  onClick={() => handleChangeTab(`${element.topic_root_tree_id}_${element.type}`)}
                />
              ))}
          </Tabs>
        </div>
        {(tab?.includes(TYPE_QUIZ) && dataTopics?.length === 0) ||
          (tab?.includes(TYPE_CARD) && listTypeCard?.items?.length === 0 && <NoDataComponent />)}
        {packageTopic && (
          <div className="pl-2">
            <span
              className="text-[13px] text-gray2"
              dangerouslySetInnerHTML={{ __html: packageTopic?.latest_data?.seo_data?.box_top }}
            />
          </div>
        )}
        {isLoading ? (
          <CXCircularProgress />
        ) : (
          <div className="mt-4 px-2">
            {tab?.includes(TYPE_CARD) ? (
              <SubjectTabCard
                location={location}
                handleClickLink={handleClickLink}
                list={listTypeCard}
                checkIsHideItem={checkIsHideItem}
                isShowLock={(accessLevel) => isShowLock(accessLevel, dataUser)}
                handleOpenModalConfirmLogin={handleOpenModalConfirmLogin}
                handleOpenModalConfirmPremium={handleOpenModalConfirmPremium}
                handleOpenModalReport={handleOpenModalReport}
                pageCurrent={pageCurrent}
                handleSetLoading={handleSetLoading}
                fetchTopics={handleGetCard}
              />
            ) : (
              dataTopics?.map((topic, idx) =>
                topic?.latest_data?.type === "lesson" ? (
                  <Box key={idx} display={tab === getTabKey(topic.latest_data) ? "block" : "none"}>
                    <SubjectLessonTab
                      lesson={getPersonalInfo(topic)}
                      handleSetHideItems={handleSetHideItems}
                      checkIsHideItem={checkIsHideItem}
                      handleClickLink={handleClickLink}
                      location={location}
                      isShowLock={(accessLevel) => isShowLock(accessLevel, dataUser)}
                      handleOpenModalConfirmLogin={handleOpenModalConfirmLogin}
                      handleOpenModalConfirmPremium={handleOpenModalConfirmPremium}
                    />
                  </Box>
                ) : (
                  <Box key={idx} display={tab === getTabKey(topic.latest_data) ? "block" : "none"}>
                    <SubjectTabExamOrPractice
                      handleClickLink={handleClickLink}
                      handleSetHideItems={handleSetHideItems}
                      list={getPersonalInfo(topic)}
                      checkIsHideItem={checkIsHideItem}
                      location={location}
                      isShowLock={(accessLevel) => isShowLock(accessLevel, dataUser)}
                      handleOpenModalConfirmLogin={handleOpenModalConfirmLogin}
                      handleOpenModalConfirmPremium={handleOpenModalConfirmPremium}
                    />
                  </Box>
                )
              )
            )}
          </div>
        )}
      </div>
      {openModalReport && (
        <ModalComplain
          open={openModalReport}
          handleClose={handleCloseModalReport}
          title={<FormattedMessage id="title.report.quiz" />}
          subtitle={<FormattedMessage id="subtitle.report.card" />}
          type={REPORT_QUIZ}
          topic={{ id: cardId }}
          openTextInput
        />
      )}
    </div>
  );
}
